import type { ElementRef, Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { SafeResourceUrl } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

import type { TellentBrand } from '@tellent/types';

import type { Ability } from '@recruitee/abilities-types';
import type { FeatureDiscoveryFeatures } from '@recruitee/feature-discovery-types';
import type {
  ComponentPositionPair,
  ComponentTooltipPosition,
  ObserveOnElement,
  OverlayClipArea,
} from '@recruitee/user-interface';

export interface FeatureTooltipData {
  id: string;
  isNew: boolean;
  title: string;
  description: string;
  learnMore?: string;
  learnMoreCopy?: string;
  ctaText?: string;
  positions?: Partial<Record<ComponentTooltipPosition, ComponentPositionPair>>;
  offsetX?: number;
  offsetY?: number;
  flagName?: keyof FeatureDiscoveryFeatures;
  requiredAbilities?: Ability[];
  brand?: TellentBrand;
}

export interface FeatureTooltipDirectiveConfig extends FeatureTooltipData {
  context: any;
  positions?: Partial<Record<ComponentTooltipPosition, ComponentPositionPair>>;
  overlayClipArea?: OverlayClipArea;
  observeOnElement?: ObserveOnElement;
  observeOnCustomElement?: Node | Signal<ElementRef<Node>>;
  withPush?: boolean;
}
export const welcomeVideoYoutubeUrl = (): SafeResourceUrl => {
  const domSanitizer = inject(DomSanitizer);
  const url = `https://www.youtube.com/embed/GTjKXVyr4lY`;
  // eslint-disable-next-line ban/ban
  return domSanitizer.bypassSecurityTrustResourceUrl(url);
};
